import { Reporter } from 'interfaces/Reporter';

export const resolvers = {
  Reporter: {
    id: (reporter: Reporter) => [reporter.name, reporter.email, reporter.phone].join('_'),
  },
};
